import styled from 'styled-components'
import { HiChevronDown } from 'react-icons/hi'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  width: 100%;
`

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const BaseSelect = styled.select`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  display: block;
  width: 100%;
  height: 40px;
  padding: 0 2.5rem 0 12px;
  border: 1px solid
    ${({ theme, $hasError }) =>
      $hasError ? theme.colors.action.danger.bg : theme.colors.borderDefault};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.action.danger.bgHover : theme.colors.borderStrong};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme, $hasError }) =>
      $hasError
        ? theme.colors.action.danger.bg
        : theme.colors.action.primary.bg};
    box-shadow: 0 0 0 3px
      ${({ theme, $hasError }) =>
        $hasError
          ? 'rgba(220, 38, 38, 0.15)'
          : 'rgba(62, 207, 142, 0.18)'};
  }

  &:disabled {
    background: ${({ theme }) =>
      theme.name === 'dark' ? theme.colors.backgroundSecondary : theme.colors.borderSubtle};
    color: ${({ theme }) => theme.colors.textMuted};
  }

  option {
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`

export const Chevron = styled(HiChevronDown)`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 1.125rem;
  height: 1.125rem;
  color: ${({ theme }) => theme.colors.textMuted};
  pointer-events: none;
`

export const ErrorText = styled.span`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.action.danger.bg};
`
